// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"02ec8a34","453":"dd9301c8"}[chunkId] + ".chunk.js";
};